import { useParams, Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

function ObfuscatedEmail({ user, domain }: { user: string; domain: string }) {
  const handleClick = () => {
    window.location.href = `mailto:${user}@${domain}`
  }
  return (
    <button
      type="button"
      onClick={handleClick}
      className="text-orion-primary hover:text-orion-primary-hover underline transition-colors cursor-pointer"
    >
      {user}&#64;{domain}
    </button>
  )
}

const LEGAL_PAGES: Record<string, { title: string; content: string }> = {
  mentions: {
    title: 'Mentions l\u00e9gales',
    content: `
      <h2>\u00c9diteur du site</h2>
      <p>Le site <strong>orionseo.fr</strong> est \u00e9dit\u00e9 par :</p>
      <ul>
        <li><strong>Raison sociale :</strong> Elorion</li>
        <li><strong>Forme juridique :</strong> SARL</li>
        <li><strong>Si\u00e8ge social :</strong> 8 rue des Cailles, 68270 Ruelisheim, France</li>
        <li><strong>Responsable de la publication :</strong> C\u00e9dric Duma</li>
        <li><strong>Email :</strong> <span id="email-mentions"></span></li>
        <li><strong>Site web :</strong> <a href="https://www.elorion.fr" target="_blank" rel="noopener noreferrer">www.elorion.fr</a></li>
      </ul>

      <h2>H\u00e9bergement</h2>
      <p>Le site est h\u00e9berg\u00e9 par :</p>
      <ul>
        <li><strong>H\u00e9bergeur :</strong> Hetzner Online GmbH</li>
        <li><strong>Adresse :</strong> Industriestr. 25, 91710 Gunzenhausen, Allemagne</li>
        <li><strong>Site web :</strong> <a href="https://www.hetzner.com" target="_blank" rel="noopener noreferrer">www.hetzner.com</a></li>
      </ul>

      <h2>Propri\u00e9t\u00e9 intellectuelle</h2>
      <p>L\u2019ensemble du contenu du site orionseo.fr (textes, images, graphismes, logo, ic\u00f4nes, logiciels) est la propri\u00e9t\u00e9 exclusive d\u2019Elorion, sauf mention contraire. Toute reproduction, repr\u00e9sentation, modification ou exploitation, m\u00eame partielle, sans autorisation pr\u00e9alable \u00e9crite, est interdite et constitue une contrefa\u00e7on sanctionn\u00e9e par le Code de la propri\u00e9t\u00e9 intellectuelle.</p>

      <h2>Limitation de responsabilit\u00e9</h2>
      <p>Elorion s\u2019efforce de fournir des informations exactes et \u00e0 jour sur le site. Toutefois, Elorion ne saurait garantir l\u2019exactitude, la compl\u00e9tude ou l\u2019actualit\u00e9 des informations diffus\u00e9es. L\u2019utilisation des informations et contenus disponibles sur le site se fait sous la responsabilit\u00e9 de l\u2019utilisateur.</p>

      <h2>Liens hypertextes</h2>
      <p>Le site peut contenir des liens vers des sites externes. Elorion n\u2019exerce aucun contr\u00f4le sur ces sites et d\u00e9cline toute responsabilit\u00e9 quant \u00e0 leur contenu ou leurs pratiques en mati\u00e8re de protection des donn\u00e9es personnelles.</p>
    `,
  },
  cgu: {
    title: "Conditions g\u00e9n\u00e9rales d\u2019utilisation",
    content: `
      <h2>Objet</h2>
      <p>Les pr\u00e9sentes Conditions G\u00e9n\u00e9rales d\u2019Utilisation (CGU) ont pour objet de d\u00e9finir les modalit\u00e9s d\u2019acc\u00e8s et d\u2019utilisation de la plateforme Orion SEO, accessible \u00e0 l\u2019adresse <strong>orionseo.fr</strong>, \u00e9dit\u00e9e par Elorion.</p>

      <h2>Acc\u00e8s \u00e0 la plateforme</h2>
      <p>L\u2019acc\u00e8s \u00e0 Orion SEO est r\u00e9serv\u00e9 aux utilisateurs disposant d\u2019un compte valide. L\u2019inscription se fait par invitation ou via authentification Google OAuth. Elorion se r\u00e9serve le droit de refuser ou de suspendre l\u2019acc\u00e8s \u00e0 tout utilisateur, sans justification pr\u00e9alable.</p>

      <h2>Description du service</h2>
      <p>Orion SEO est une plateforme d\u2019analyse et de suivi SEO qui propose :</p>
      <ul>
        <li>L\u2019audit technique de sites web (crawl, erreurs, performance)</li>
        <li>Le suivi de positionnement sur les moteurs de recherche</li>
        <li>L\u2019analyse des Core Web Vitals et de la performance</li>
        <li>L\u2019analyse de la visibilit\u00e9 IA (AI Overviews, LLM)</li>
        <li>La g\u00e9n\u00e9ration de rapports SEO</li>
        <li>L\u2019analyse assist\u00e9e par intelligence artificielle</li>
      </ul>

      <h2>Obligations de l\u2019utilisateur</h2>
      <p>L\u2019utilisateur s\u2019engage \u00e0 :</p>
      <ul>
        <li>Utiliser la plateforme conform\u00e9ment \u00e0 sa destination et aux pr\u00e9sentes CGU</li>
        <li>Ne pas tenter d\u2019acc\u00e9der \u00e0 des donn\u00e9es ou fonctionnalit\u00e9s non autoris\u00e9es</li>
        <li>Ne pas utiliser la plateforme \u00e0 des fins illicites ou portant atteinte aux droits de tiers</li>
        <li>Maintenir la confidentialit\u00e9 de ses identifiants de connexion</li>
      </ul>

      <h2>Propri\u00e9t\u00e9 intellectuelle</h2>
      <p>La plateforme Orion SEO, son interface, ses algorithmes, son code source et l\u2019ensemble de ses contenus sont la propri\u00e9t\u00e9 exclusive d\u2019Elorion. Toute reproduction ou utilisation non autoris\u00e9e est interdite.</p>

      <h2>Disponibilit\u00e9 du service</h2>
      <p>Elorion s\u2019efforce d\u2019assurer la disponibilit\u00e9 de la plateforme 24h/24, 7j/7. Toutefois, l\u2019acc\u00e8s peut \u00eatre temporairement interrompu pour des raisons de maintenance, de mise \u00e0 jour ou en cas de force majeure. Elorion ne saurait \u00eatre tenue responsable des interruptions de service.</p>

      <h2>Responsabilit\u00e9</h2>
      <p>Les donn\u00e9es et analyses fournies par Orion SEO sont donn\u00e9es \u00e0 titre indicatif. Elorion ne garantit pas l\u2019exactitude absolue des r\u00e9sultats et ne saurait \u00eatre tenue responsable des d\u00e9cisions prises sur la base de ces analyses.</p>

      <h2>Modification des CGU</h2>
      <p>Elorion se r\u00e9serve le droit de modifier les pr\u00e9sentes CGU \u00e0 tout moment. Les utilisateurs seront inform\u00e9s des modifications par notification sur la plateforme. L\u2019utilisation continue de la plateforme vaut acceptation des CGU modifi\u00e9es.</p>

      <h2>Droit applicable</h2>
      <p>Les pr\u00e9sentes CGU sont soumises au droit fran\u00e7ais. Tout litige relatif \u00e0 l\u2019utilisation de la plateforme sera soumis aux tribunaux comp\u00e9tents de Mulhouse.</p>
    `,
  },
  confidentialite: {
    title: 'Politique de confidentialit\u00e9',
    content: `
      <h2>Introduction</h2>
      <p>Elorion s\u2019engage \u00e0 prot\u00e9ger la vie priv\u00e9e des utilisateurs de la plateforme Orion SEO. La pr\u00e9sente politique d\u00e9crit les donn\u00e9es personnelles collect\u00e9es, les finalit\u00e9s du traitement et les droits des utilisateurs conform\u00e9ment au R\u00e8glement G\u00e9n\u00e9ral sur la Protection des Donn\u00e9es (RGPD).</p>

      <h2>Responsable du traitement</h2>
      <ul>
        <li><strong>Responsable :</strong> C\u00e9dric Duma - Elorion (SARL)</li>
        <li><strong>Email :</strong> <span id="email-privacy"></span></li>
        <li><strong>Adresse :</strong> 8 rue des Cailles, 68270 Ruelisheim, France</li>
      </ul>

      <h2>Donn\u00e9es collect\u00e9es</h2>
      <p>Dans le cadre de l\u2019utilisation d\u2019Orion SEO, les donn\u00e9es suivantes peuvent \u00eatre collect\u00e9es :</p>
      <ul>
        <li><strong>Donn\u00e9es d\u2019identification :</strong> nom, pr\u00e9nom, adresse email (via Google OAuth)</li>
        <li><strong>Donn\u00e9es de connexion :</strong> adresse IP, type de navigateur, horodatage des connexions</li>
        <li><strong>Donn\u00e9es d\u2019utilisation :</strong> projets cr\u00e9\u00e9s, audits lanc\u00e9s, pages analys\u00e9es, rapports g\u00e9n\u00e9r\u00e9s</li>
        <li><strong>Donn\u00e9es techniques :</strong> cookies de session (JWT httpOnly) n\u00e9cessaires au fonctionnement de l\u2019authentification</li>
      </ul>

      <h2>Finalit\u00e9s du traitement</h2>
      <p>Les donn\u00e9es sont trait\u00e9es pour les finalit\u00e9s suivantes :</p>
      <ul>
        <li>Fourniture et fonctionnement de la plateforme Orion SEO</li>
        <li>Authentification et s\u00e9curisation de l\u2019acc\u00e8s</li>
        <li>Am\u00e9lioration du service et de l\u2019exp\u00e9rience utilisateur</li>
        <li>Communication relative au service (notifications, alertes)</li>
        <li>Respect des obligations l\u00e9gales</li>
      </ul>

      <h2>Base l\u00e9gale</h2>
      <p>Le traitement des donn\u00e9es est fond\u00e9 sur :</p>
      <ul>
        <li><strong>L\u2019ex\u00e9cution du contrat :</strong> fourniture du service souscrit</li>
        <li><strong>L\u2019int\u00e9r\u00eat l\u00e9gitime :</strong> am\u00e9lioration et s\u00e9curisation du service</li>
        <li><strong>L\u2019obligation l\u00e9gale :</strong> conservation des logs de connexion</li>
      </ul>

      <h2>Dur\u00e9e de conservation</h2>
      <ul>
        <li><strong>Donn\u00e9es de compte :</strong> conserv\u00e9es pendant la dur\u00e9e d\u2019utilisation du service, puis 3 ans apr\u00e8s la derni\u00e8re connexion</li>
        <li><strong>Donn\u00e9es de connexion :</strong> 12 mois conform\u00e9ment \u00e0 la l\u00e9gislation en vigueur</li>
        <li><strong>Donn\u00e9es d\u2019utilisation :</strong> conserv\u00e9es pendant la dur\u00e9e d\u2019utilisation du service</li>
      </ul>

      <h2>Destinataires des donn\u00e9es</h2>
      <p>Les donn\u00e9es personnelles sont accessibles uniquement \u00e0 :</p>
      <ul>
        <li>C\u00e9dric Duma, en tant que responsable du traitement</li>
        <li>L\u2019h\u00e9bergeur Hetzner, dans le cadre de l\u2019h\u00e9bergement technique</li>
        <li>Google, dans le cadre de l\u2019authentification OAuth</li>
      </ul>
      <p>Aucune donn\u00e9e personnelle n\u2019est vendue, lou\u00e9e ou transmise \u00e0 des tiers \u00e0 des fins commerciales.</p>

      <h2>Transferts hors UE</h2>
      <p>L\u2019authentification Google OAuth peut impliquer un transfert de donn\u00e9es vers les \u00c9tats-Unis, encadr\u00e9 par les clauses contractuelles types de la Commission europ\u00e9enne et le Data Privacy Framework.</p>

      <h2>S\u00e9curit\u00e9</h2>
      <p>Elorion met en \u0153uvre des mesures techniques et organisationnelles appropri\u00e9es pour prot\u00e9ger les donn\u00e9es personnelles :</p>
      <ul>
        <li>Authentification s\u00e9curis\u00e9e via Google OAuth</li>
        <li>Cookies JWT httpOnly (non accessibles en JavaScript)</li>
        <li>Chiffrement des communications (HTTPS/TLS)</li>
        <li>Acc\u00e8s restreint aux donn\u00e9es (principe du moindre privil\u00e8ge)</li>
        <li>H\u00e9bergement s\u00e9curis\u00e9 chez Hetzner (certifi\u00e9 ISO 27001)</li>
      </ul>

      <h2>Cookies</h2>
      <p>Orion SEO utilise uniquement des cookies strictement n\u00e9cessaires au fonctionnement de la plateforme :</p>
      <ul>
        <li><strong>Cookie de session (JWT) :</strong> authentification de l\u2019utilisateur, dur\u00e9e de vie limit\u00e9e</li>
      </ul>
      <p>Aucun cookie publicitaire ou de tracking tiers n\u2019est utilis\u00e9.</p>

      <h2>Droits des utilisateurs</h2>
      <p>Conform\u00e9ment au RGPD, vous disposez des droits suivants :</p>
      <ul>
        <li><strong>Droit d\u2019acc\u00e8s :</strong> obtenir une copie de vos donn\u00e9es personnelles</li>
        <li><strong>Droit de rectification :</strong> corriger des donn\u00e9es inexactes</li>
        <li><strong>Droit \u00e0 l\u2019effacement :</strong> demander la suppression de vos donn\u00e9es</li>
        <li><strong>Droit \u00e0 la limitation :</strong> restreindre le traitement de vos donn\u00e9es</li>
        <li><strong>Droit \u00e0 la portabilit\u00e9 :</strong> recevoir vos donn\u00e9es dans un format structur\u00e9</li>
        <li><strong>Droit d\u2019opposition :</strong> vous opposer au traitement de vos donn\u00e9es</li>
      </ul>
      <p>Pour exercer ces droits, contactez-nous \u00e0 : <span id="email-rights"></span></p>

      <h2>R\u00e9clamation</h2>
      <p>Si vous estimez que le traitement de vos donn\u00e9es personnelles constitue une violation du RGPD, vous avez le droit d\u2019introduire une r\u00e9clamation aupr\u00e8s de la CNIL (Commission Nationale de l\u2019Informatique et des Libert\u00e9s) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a></p>

      <h2>Mise \u00e0 jour</h2>
      <p>La pr\u00e9sente politique de confidentialit\u00e9 peut \u00eatre modifi\u00e9e \u00e0 tout moment. La date de derni\u00e8re mise \u00e0 jour est indiqu\u00e9e ci-dessous.</p>
      <p><strong>Derni\u00e8re mise \u00e0 jour : avril 2026</strong></p>
    `,
  },
}

// Inject obfuscated email into spans after render
function useObfuscatedEmails() {
  const injectEmail = () => {
    const ids = ['email-mentions', 'email-privacy', 'email-rights']
    ids.forEach((id) => {
      const el = document.getElementById(id)
      if (el && !el.hasChildNodes()) {
        const link = document.createElement('a')
        link.href = ['mai', 'lto:', 'hel', 'lo@', 'elo', 'rion', '.fr'].join('')
        link.className = 'text-orion-primary hover:text-orion-primary-hover underline transition-colors'
        link.textContent = ['hel', 'lo', '@', 'elo', 'rion', '.fr'].join('')
        el.appendChild(link)
      }
    })
  }
  return injectEmail
}

export default function Legal() {
  const { page } = useParams<{ page: string }>()
  const legal = page ? LEGAL_PAGES[page] : null
  const injectEmail = useObfuscatedEmails()

  if (!legal) {
    return (
      <div className="min-h-screen bg-light-body flex items-center justify-center">
        <div className="text-center">
          <p className="text-[#8B8FA7] mb-4">Page introuvable</p>
          <Link to="/projects" className="text-orion-primary hover:text-orion-primary-hover transition-colors">
            Retour \u00e0 l&apos;accueil
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-light-body">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link
          to="/projects"
          className="inline-flex items-center gap-2 text-sm text-[#8B8FA7] hover:text-orion-primary transition-colors mb-8"
        >
          <ArrowLeft size={16} />
          Retour
        </Link>

        <div className="bg-white border border-light-border rounded-2xl p-8 sm:p-10">
          <div className="flex items-center gap-3 mb-8">
            <img src="/logo-orion.png" alt="Orion SEO" className="h-8" />
          </div>

          <h1 className="text-2xl font-semibold text-[#1B2559] mb-8">{legal.title}</h1>

          <div
            ref={(el) => { if (el) setTimeout(injectEmail, 0) }}
            className="legal-content text-sm text-[#555A73] leading-relaxed space-y-4
              [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-[#1B2559] [&_h2]:mt-8 [&_h2]:mb-3
              [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1
              [&_a]:text-orion-primary [&_a]:hover:text-orion-primary-hover [&_a]:underline [&_a]:transition-colors
              [&_strong]:text-[#1B2559]"
            dangerouslySetInnerHTML={{ __html: legal.content }}
          />
        </div>

        <p className="text-center text-xs text-[#8B8FA7] mt-6">
          &copy; {new Date().getFullYear()} Elorion. Tous droits r\u00e9serv\u00e9s.
        </p>
      </div>
    </div>
  )
}
